
window.Simditor = require('simditor');

require('simditor-i18n');
require('simditor-alignments');
require('simditor-markdown-github');
require('angular-simditor');
require('compartilhado/extensions/simditor-date-button/simditor-date-button.coffee');

import 'simditor/styles/simditor.css';
import 'simditor-markdown-github/styles/simditor-markdown-github.css';



// WEBPACK FOOTER //
// ./src/core/config/simditor.js